Object.defineProperty(exports,"__esModule",{value: true});
exports.default=window.GrimoireJS&&window.GrimoireJS.lib.math?window.GrimoireJS.lib.math.Quaternion:undefined;



//////////////////
// WEBPACK FOOTER
// ./node_modules/grimoirejs-math/ref/Quaternion.js
// module id = 121
// module chunks = 0